<template>
  <BaseLoading v-if="isAvatarsLoading" />
  <b-row
    v-else
    class="w-100 d-flex justify-content-center"
  >
    <b-col
      v-for="avatar in avatars"
      :key="`avatar-${avatar.id}`"
      :cols="4"
      :sm="3"
      :md="2"
      :lg="1"
      class="pt-4"
    >
      <b-img
        :src="avatar.image_url"
        fluid
        :class="[
          $style.image,
          avatar.id === userAvatar.id && $style.isSelected
        ]"
        @click="() => handleAvatarChange({ avatarId: avatar.id })"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { buildNotification } from '@/helpers/ui'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  name: 'ChangeAvatar',
  components: { BaseLoading },
  metaInfo() {
    return {
      title: this.$t('page-titles.profile-change-avatar'),
    }
  },
  computed: {
    ...mapState({
      isAvatarsLoading: state => state['profile/avatar'].isAvatarsLoading,
      avatars: state => state['profile/avatar'].avatars,
    }),
    ...mapGetters({
      userAvatar: 'auth/getUserCurrentAvatar',
    }),
  },
  created() {
    this.fetchAllAvatars()
  },
  methods: {
    ...mapActions({
      changeAvatar: 'profile/avatar/changeAvatar',
      fetchAllAvatars: 'profile/avatar/fetchAllAvatars',
    }),
    handleAvatarChange({ avatarId }) {
      this.changeAvatar({ avatarId })
      buildNotification({
        title: this.$t('your-avatar-was-successfully-updated'),
      })
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .image {
    transition: all .3s ease-in-out;
    cursor: pointer;
    border-radius: 50%;
  }
  .isSelected {
    border: 6px solid $color-tomato;
    box-shadow: 0 0 7px 0 $color-benihi-red;
  }
</style>
